import { render, staticRenderFns } from "./Platform.vue?vue&type=template&id=14bb96fe&scoped=true&"
import script from "./Platform.vue?vue&type=script&lang=js&"
export * from "./Platform.vue?vue&type=script&lang=js&"
import style0 from "./Platform.vue?vue&type=style&index=0&id=14bb96fe&lang=scss&scoped=true&"
import style1 from "./Platform.vue?vue&type=style&index=1&id=14bb96fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14bb96fe",
  null
  
)

/* custom blocks */
import block0 from "./Platform.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports